import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const Plays = ({
  partida,
  set,
  numScout,
  onChangeScore,
  placar,
  onPlacarGeral,
  refreshKey,
}) => {
  const [jogadas, setJogadas] = useState([]);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  const fetchLastMatch = async () => {
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/set/last20`,
        {
          set: Number(set),
          partida,
        }
      );
      setJogadas(response?.data[0]?.last20Scouts || []);

      const newPlacar = response?.data[0]?.last20Scouts.at(-1)?.score;
      if (JSON.stringify(placar) !== JSON.stringify(newPlacar)) {
        onChangeScore(newPlacar);
      }
    } catch (error) {
      console.error("Erro ao buscar as jogadas:", error);
    }
  };

  useEffect(() => {
    fetchLastMatch();
  }, [set, partida, refreshKey]);

  const handleRemove = async (index, cod) => {
    const confirm = window.confirm("Deseja realmente remover esta jogada?");
    const scoutId = jogadas[index]["id"];
    if (!confirm) return;

    // const realIndex = numScout - index - 1;

    try {
      await axios.delete(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/matches/partida/scout/remove/${partida}/${scoutId}`
      );

      // Atualiza a lista
      fetchLastMatch();
      onPlacarGeral((prev) => !prev);
      if (cod === "**nSet") {
        window.location.reload();
      }
    } catch (error) {
      console.error("Erro ao remover a jogada:", error);
      alert("Erro ao remover a jogada.");
    }
  };

  return (
    <div className="text-white mb-6 max-w-[200px]">
      {jogadas.length === 0 && <p>Carregando jogadas...</p>}

      {!isAdminRoute && (
        <span className="text-gray-400">
          <p>Evolução dos pontos</p>
        </span>
      )}
      <table className="w-full table-fixed text-sm">
        <thead>
          <tr className="text-gray-400">
            {isAdminRoute && <th className="text-left w-1/3">Código</th>}
            <th className="text-center w-1/3">Local</th>
            <th className="text-center w-1/3">Visitante</th>
          </tr>
        </thead>
        <tbody>
          {jogadas.map((j, idx, arr) => {
            const prev = arr[idx - 1];
            const showScore0 = !prev || j.score?.[0] !== prev.score?.[0];
            const showScore1 = !prev || j.score?.[1] !== prev.score?.[1];

            return (
              <tr key={idx}>
                {isAdminRoute && (
                  <td
                    className="text-gray-400 cursor-pointer hover:underline"
                    onClick={() => handleRemove(idx, j.cod)}
                    title="Clique para remover"
                  >
                    {j.cod}
                  </td>
                )}
                <td className="text-center pb-1">
                  {showScore0 && (
                    <span className="bg-blue-500 text-white px-2 py-0.5 rounded">
                      {j.score?.[0]}
                    </span>
                  )}
                </td>
                <td className="text-center pb-1">
                  {showScore1 && (
                    <span className="bg-red-500 text-white px-2 py-0.5 rounded">
                      {j.score?.[1]}
                    </span>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Plays;
